import { TTag } from '../../types/tags';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ETagsActionType } from './types';

export const removeTag = actionGenerator<ETagsActionType.Removed, TTag>(ETagsActionType.Removed);
